/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SoftwareEnvironmentAliasListSchema } from './SoftwareEnvironmentAliasListSchema';
import {
    SoftwareEnvironmentAliasListSchemaFromJSON,
    SoftwareEnvironmentAliasListSchemaFromJSONTyped,
    SoftwareEnvironmentAliasListSchemaToJSON,
} from './SoftwareEnvironmentAliasListSchema';

/**
 * 
 * @export
 * @interface PagedSoftwareEnvironmentAliasListSchema
 */
export interface PagedSoftwareEnvironmentAliasListSchema {
    /**
     * 
     * @type {Array<SoftwareEnvironmentAliasListSchema>}
     * @memberof PagedSoftwareEnvironmentAliasListSchema
     */
    items: Array<SoftwareEnvironmentAliasListSchema>;
    /**
     * 
     * @type {number}
     * @memberof PagedSoftwareEnvironmentAliasListSchema
     */
    count: number;
}

/**
 * Check if a given object implements the PagedSoftwareEnvironmentAliasListSchema interface.
 */
export function instanceOfPagedSoftwareEnvironmentAliasListSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function PagedSoftwareEnvironmentAliasListSchemaFromJSON(json: any): PagedSoftwareEnvironmentAliasListSchema {
    return PagedSoftwareEnvironmentAliasListSchemaFromJSONTyped(json, false);
}

export function PagedSoftwareEnvironmentAliasListSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedSoftwareEnvironmentAliasListSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(SoftwareEnvironmentAliasListSchemaFromJSON)),
        'count': json['count'],
    };
}

export function PagedSoftwareEnvironmentAliasListSchemaToJSON(value?: PagedSoftwareEnvironmentAliasListSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(SoftwareEnvironmentAliasListSchemaToJSON)),
        'count': value.count,
    };
}

